import { render } from "./HeaderNav.vue?vue&type=template&id=848b1690&scoped=true"
const script = {}

import "./HeaderNav.vue?vue&type=style&index=0&id=848b1690&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-848b1690"

export default script